module.exports = __webpack_public_path__ + "media/images/file-icons/256/001-interface-1-1658edc8664bbb15b9a26ac8adc73a6b.png";